// The privacy policy and the legal notice on todolix.app, in the web app's language: linked under the sign-in, where
// the account's data is collected (GDPR Art. 13), and in Settings (the legal notice easy to reach, § 5 DDG). The apps
// link the same pages (AppLinks in the kit).

import { currentLanguage, t } from "../i18n";

export function privacyURL(): string {
  return currentLanguage() === "de" ? "https://todolix.app/de/datenschutz" : "https://todolix.app/privacy";
}

export function legalNoticeURL(): string {
  return currentLanguage() === "de" ? "https://todolix.app/de/impressum" : "https://todolix.app/legal-notice";
}

export function LegalLinks({ className }: { className: string }) {
  return (
    <p className={className}>
      <a href={privacyURL()} target="_blank" rel="noopener">{t("Privacy Policy")}</a>
      <span aria-hidden="true"> · </span>
      <a href={legalNoticeURL()} target="_blank" rel="noopener">{t("Legal Notice")}</a>
    </p>
  );
}
